import {Database} from '../../types/database.types';
import {ColumnSelectionT} from '../../types/query.types';

/**
 * Function to convert columns to a string.
 * @param {ColumnSelectionT} columns - The columns to convert.
 * @returns {string} - The string of columns.
 */
export function convertColumnsToString<T extends keyof Database['public']['Tables']>(
  columns: ColumnSelectionT<T>[]
): string {
  return columns
    .map(column => {
      if (typeof column === 'string') {
        return column;
      } else if (Array.isArray(column)) {
        const [relation, innerColumns] = column;
        const innerColumnsStr = convertColumnsToString<T>(innerColumns as ColumnSelectionT<T>[]);
        return `${relation}(${innerColumnsStr})`;
      }
      return '';
    })
    .join(',');
}
